import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { DeleteProjectPayload } from '@/generated/types';

const DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id) {
      success
    }
  }
`;

const PROJECTS_QUERY = gql`
  query Projects($first: Int, $after: String, $status: ProjectStatus) {
    projects(first: $first, after: $after, status: $status) {
      edges {
        node {
          id
          name
          address
          status
          startDate
          endDate
          creator {
            fullName
          }
          members {
            id
            fullName
          }
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

interface UseDeleteProjectOptions {
  onCompleted?: () => void;
}

export function useDeleteProject(options?: UseDeleteProjectOptions) {
  const [deleteProjectMutation, { loading, error }] = useMutation(DELETE_PROJECT_MUTATION, {
    onCompleted: options?.onCompleted,
  });

  const deleteProject = async (id: string) => {
    const { data } = await deleteProjectMutation({
      variables: { id },
      refetchQueries: [{ query: PROJECTS_QUERY }],
    });
    return (data as { deleteProject?: DeleteProjectPayload } | undefined)?.deleteProject?.success;
  };

  return { deleteProject, loading, error };
}
